import { render } from "./pagination.vue?vue&type=template&id=260720e6&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=260720e6&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260720e6"]])

export default __exports__